import { type Identifier, useGetManyAggregate } from "ra-core";

import type { NoteChannel } from "../types";

/**
 * The channel a note has, or undefined for a note without one.
 * useGetManyAggregate folds every lookup on the page into one request, and a
 * rename or recolour in Settings reaches them all through its cache. LCCRM-87.
 */
export const useNoteChannel = (
  channelId: Identifier | null | undefined,
): NoteChannel | undefined => {
  const { data } = useGetManyAggregate<NoteChannel>(
    "note_channels",
    { ids: channelId != null ? [channelId] : undefined },
    { enabled: channelId != null },
  );
  return channelId != null ? data?.[0] : undefined;
};
